import { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from "react-router-dom"
// services
import * as webBridgeService from '../../../services/webBridgeService'
import * as accountService from '../../../services/accountService'
// styles
import styles from "./RegisterExhibitor.module.css"
// components
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
import HoverButton from '../../../components/Miscellaneous/HoverButton'
// url example -     https://localhost:3003/registerExhibitor/6b8633a6-078d-4fc2-9d05-1a88b8a218a7/cat
const RegisterExhibitor = () => {
    const navigate = useNavigate()
    const { id, passcode } = useParams();    
    const [loaded, setLoaded] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [exhibitorItem, setExhibitorItem] = useState(null);
    const [txtCaptchaHidden, setTxtCaptchaHidden] = useState(null)
    const [txtCaptcha, setTxtCaptcha] = useState(null)
    const [captchaInput, setCaptchaInput] = useState(null)
    const [captchaDiv, setCaptchaDiv] = useState(null)
    const [formData, setFormData] = useState(
        {
            id: null,
            exhibitorId: id, 
            passcode: passcode, 
            organization: null,
            exEmail: null,
            exFirstName: null,
            exLastName: null,
            email: null,    //ohoy/bot catches
            firstName: null,//ohoy/bot catches
            lastName: null,//ohoy/bot catches
        }
    )
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        })
    }
    function removeSpaces(entry) {
        if (!entry || entry.length < 1) {
            return '';
        }
        return entry.split(' ').join('');
    }
    function checkForm() {
        var why = "";
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2) {
            why = "";
        }
        else {
            why += "- The CAPTCHA Code Does Not Match.\n";
        }
        if (why !== "") {
            setTxtCaptchaHidden(why);
        } else {
            setTxtCaptchaHidden(''); //Good

        }
    }
    // Validate input against the generated number
    function ValidCaptcha() {
        var str1 = removeSpaces(txtCaptcha);
        var str2 = removeSpaces(captchaInput);
        if (str1 === str2 && str1.length > 0 && str2.length > 0) {
            return true;
        } else {
            return false;
        }
    }
    const isFormValid = () => {
        return !(formData.exFirstName &&
            formData.exLastName &&
            formData.exhibitorId &&
            formData.exEmail &&
            passcode &&
            ValidCaptcha());
    }
    const createSaveRequest = (item) => {       
        // holds everything
        const fieldsSave = {
            'id': item.id && item.id !== undefined ? item.id : null,
            'exhibitorId': item.exhibitorId,
            'leadCaptureId': exhibitorItem.leadCaptureId,
            'passcode': item.passcode,
            'organization': item.organization,
            'firstName': item.exFirstName,
            'lastName': item.exLastName,
            'userName': item.exEmail,
            'password': item.password,
            'roleName': 'Admin',// exhibitor will be created by different process, auto create password for the accounts
        }
        return fieldsSave
    }
    const handleAddUpdate = async (item) => {
        let saveReq = await createSaveRequest(item);
        await accountService.addUpdateAccount(saveReq);
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            // check the bots fields
            if (formData.firstname || formData.lastName || formData.email) {
                // assume its a bot, go to login page, but don't create/save account
                navigate('/Login');
            }
            await handleAddUpdate(formData);
            navigate('/Login');

        } catch (err) {
            //setMessage(err.message)
        }
    }
    useEffect(() => {
        if (captchaInput && captchaInput !== undefined && captchaInput.length > 0) {
            checkForm();
        }
    }, [captchaInput])
    useEffect(() => {
        //window.addEventListener("keyup", (e) => {
        //    checkForm();
        //});
        var a = Math.ceil(Math.random() * 9) + '';
        var b = Math.ceil(Math.random() * 9) + '';
        var c = Math.ceil(Math.random() * 9) + '';
        var d = Math.ceil(Math.random() * 9) + '';
        var e = Math.ceil(Math.random() * 9) + '';
        var code = a + b + c + d + e;
        setTxtCaptcha(code);
        setCaptchaDiv(code);
    }, [loaded]);
    const fetchExhibitor = async () => {
        let exItem = await webBridgeService.fetchExhibitorById(id);
        if (exItem && exItem.refNumber && exItem.refNumber > 0) {
            setExhibitorItem(exItem);
            // pre load with purhcase info?
            formData.email = exItem.email;
            formData.firstName = exItem.firstName;
            formData.lastName = exItem.lastName;
            formData.organization = exItem.organization;
            setFormData({
                ...formData
            })
            // check if there's already an account with the same email address
            let existingAccount = await accountService.getAccountByUsername(formData.email);
            if (existingAccount && existingAccount.userName) {
                //account was found
                setShowLogin(true);
                // update account
                formData.id = existingAccount.id;
                formData.firstName = existingAccount.firstName;
                formData.lastName = existingAccount.lastName;
                formData.organization = existingAccount.organization;
                formData.parentId = existingAccount.parentId;
                setFormData({
                    ...formData
                })
                await handleAddUpdate(formData);
            }
        }
        setLoaded(true);
    }
    useEffect(() => {
        if (id && id !== undefined) {
            fetchExhibitor()
        }
    }, [])
    return (
         <>{!loaded ? <LoadingSpinner /> :
            <>
                {exhibitorItem && exhibitorItem.refNumber !== undefined && !showLogin ?
                    <div className={styles.registerExhibitorContainer}>
                        <h4>Create a new account.</h4>
                        <h2>Profile Details</h2><br />
                        <h4>Note: initial profile information is tied to service purchase invoice.<br />Change entries to match your information. </h4>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exFirstName" className={styles.label}>First Name:
                                            <HoverButton
                                                title={'Account first name.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="3"
                                            type="text"
                                            autoComplete="off"
                                            name="exFirstName"
                                            value={formData.exFirstName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exLastName" className={styles.label}>Last Name:
                                            <HoverButton
                                                title={'Account last name.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="5"
                                            type="text"
                                            autoComplete="off"
                                            name="exLastName"
                                            value={formData.exLastName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="exEmail" className={styles.label}>Email Address:
                                            <HoverButton
                                                title={'Account email.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="1"
                                            type="text"
                                            autoComplete="off"
                                            name="exEmail"
                                            value={formData.exEmail}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="organization" className={styles.label}>Organization:
                                            <HoverButton
                                                title={'Account organization.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="2"
                                            type="text"
                                            autoComplete="off"
                                            name="organization"
                                            value={formData.organization}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.parentContainer}>
                            <div className={styles.leftContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="password" className={styles.label}>Password:
                                            <HoverButton
                                                title={'Account password.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="1"
                                            type="text"
                                            autoComplete="off"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightContainer}>
                                <div className={styles.parentContainer}>
                                    <div className={styles.leftContainer}>
                                        <label htmlFor="confpassword" className={styles.label}>Confirm Password:
                                            <HoverButton
                                                title={'Account password confirmation.'}
                                                messageWidth={75}
                                            />
                                        </label>
                                    </div>
                                    <div className={styles.rightContainer}>
                                        <input
                                            tabIndex="2"
                                            type="text"
                                            autoComplete="off"
                                            name="confpassword"
                                            value={formData.confpassword}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br /><br />
                        <div className={styles.capbox}>
                            <div id='CaptchaDiv'>{captchaDiv}
                                <div className={styles.capboxInner}>
                                    Type the number:<br />

                                </div>
                                <input
                                    type="text"
                                    autoComplete="off"
                                    name="captchaInput"
                                    value={captchaInput}
                                    onChange={handleChange}
                                    id="captchaInput"
                                /><br />
                                <input
                                    type="hidden"
                                    autoComplete="off"
                                    name="txtCaptcha"
                                    value={txtCaptcha}
                                    onChange={handleChange}
                                    id="txtCaptcha"
                                />
                            </div>
                        </div>
                        <div style={{ color: 'red' }}>
                            {txtCaptchaHidden}
                        </div>
                        <br /><br />
                        <button onClick={e => handleSubmit(e)} disabled={isFormValid()} className={styles.editButtons}>
                            Create account...
                        </button>
                    </div>
                    : <>{showLogin ?
                        <>
                            <div>
                            <h3> Account already exists, please try to login.</h3>
                                <Link to="/Login" className={styles.change}>
                                    <button className={styles.button}>Login</button>
                                </Link>  
                            </div>
                            
                            </>
  
                        : 
                        <h1>Invalid link!</h1>}
                    </>
                    }
                <br /><br />
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            </>

        }
        </>


    );
}
export default RegisterExhibitor;